var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-data-table", {
    staticClass: "table-less-padding",
    attrs: {
      headers: _vm.headers,
      items: _vm.travelServiceOrders,
      "sort-by": _vm.pagination.sortBy,
      "sort-desc": _vm.pagination.descending,
      loading: _vm.$store.getters["Ajax/loading"] ? "accent" : false
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.pagination, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.pagination, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.pagination, "descending", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.pagination, "descending", $event)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "item",
        fn: function(props) {
          return [
            _c("tr", [
              _c("td", { staticClass: "text-no-wrap" }, [
                _vm._v(_vm._s(props.item.created_at))
              ]),
              _c("td", { staticClass: "text-no-wrap" }, [
                _vm._v(_vm._s(props.item.created_by_name))
              ]),
              _c(
                "td",
                [
                  _c(
                    "v-row",
                    _vm._l(props.item.travel_service_items, function(
                      travelServiceItem
                    ) {
                      return _c(
                        "div",
                        { key: travelServiceItem.id, staticClass: "ma-1" },
                        [
                          _c("travel-service-order-item-chip", {
                            attrs: {
                              "travel-service-order-item": travelServiceItem
                            }
                          })
                        ],
                        1
                      )
                    }),
                    0
                  )
                ],
                1
              ),
              _c("td", { staticClass: "text-center" }, [
                _c(
                  "span",
                  {
                    staticClass: "mx-1",
                    staticStyle: { "text-align": "center" }
                  },
                  [_c("order-chip", { attrs: { status: props.item.status } })],
                  1
                )
              ]),
              _c(
                "td",
                { staticClass: "text-no-wrap" },
                [
                  _vm.unpin
                    ? _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          attrs: { icon: "" },
                                          on: {
                                            click: function($event) {
                                              return _vm.$emit(
                                                "unpin",
                                                props.item.id
                                              )
                                            }
                                          }
                                        },
                                        on
                                      ),
                                      [_c("v-icon", [_vm._v("fa-times")])],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("global.unAssign")) + " ")]
                      )
                    : _vm._e(),
                  props.item.created_by_id ===
                    _vm.$store.state.Auth.userProperties.user_id ||
                  _vm.$store.getters.hasPermission("travelOrder")
                    ? _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    props.item.status ===
                                      _vm.serviceStatus.STATUS_CREATED ||
                                    props.item.status ===
                                      _vm.serviceStatus
                                        .STATUS_PARTLY_COMPLETED ||
                                    props.item.status ===
                                      _vm.serviceStatus.STATUS_SEND
                                      ? _c(
                                          "v-btn",
                                          _vm._g(
                                            {
                                              attrs: { icon: "" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.$emit(
                                                    "edit",
                                                    props.item.id
                                                  )
                                                }
                                              }
                                            },
                                            on
                                          ),
                                          [
                                            _c("v-icon", [
                                              _vm._v("remove_red_eye")
                                            ])
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("travelService.goToOrderDetail")) +
                              " "
                          )
                        ]
                      )
                    : _vm._e(),
                  props.item.status === _vm.serviceStatus.STATUS_SEND &&
                  (_vm.$store.state.Auth.userProperties.user_id ===
                    props.item.created_by_id ||
                    _vm.$store.getters.hasPermission("travelOrder"))
                    ? _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          attrs: { icon: "" },
                                          on: {
                                            click: function($event) {
                                              return _vm.$emit(
                                                "choose-offer",
                                                props.item.id
                                              )
                                            }
                                          }
                                        },
                                        on
                                      ),
                                      [
                                        _c("v-icon", [
                                          _vm._v("fa-clipboard-list")
                                        ])
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("travelService.chooseOffer")) +
                              " "
                          )
                        ]
                      )
                    : _vm._e(),
                  _c("cancellation-component", {
                    attrs: { travel_service: props.item },
                    on: {
                      changed: function($event) {
                        return _vm.$emit("changed")
                      }
                    }
                  }),
                  props.item.can_be_accepted
                    ? _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          attrs: { icon: "" },
                                          on: {
                                            click: function($event) {
                                              return _vm.$emit(
                                                "approval",
                                                props.item.id
                                              )
                                            }
                                          }
                                        },
                                        on
                                      ),
                                      [
                                        _c("v-icon", [
                                          _vm._v("fa-clipboard-check")
                                        ])
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("travelService.approvalForm")) +
                              " "
                          )
                        ]
                      )
                    : _vm._e(),
                  [
                    _vm.serviceStatus.STATUS_COMPLETE,
                    _vm.serviceStatus.STATUS_CANCELLATION_REQUEST
                  ].includes(props.item.status) &&
                  (_vm.$store.getters.isAdmin || props.item.can_view_vouchers)
                    ? _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          attrs: { icon: "" },
                                          on: {
                                            click: function($event) {
                                              return _vm.$emit(
                                                "booked",
                                                props.item.id
                                              )
                                            }
                                          }
                                        },
                                        on
                                      ),
                                      [_c("v-icon", [_vm._v("fa-ticket-alt")])],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("travelService.tickets")) + " "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._l(props.item.travel_service_items, function(item) {
                    return [
                      [
                        _vm.itemsStatus.STATUS_REQUEST_CLIENT_ANSWER_FOR_BOOK,
                        _vm.itemsStatus.STATUS_REQUEST_CLIENT_ANSWER_FOR_OFFER
                      ].includes(item.status) &&
                      (props.item.created_by_id ===
                        _vm.$store.state.Auth.userProperties.user_id ||
                        _vm.$store.getters.hasPermission("travelOrder"))
                        ? _c(
                            "v-tooltip",
                            {
                              key: item.id,
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            {
                                              attrs: { icon: "" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.$emit(
                                                    "message",
                                                    item.id
                                                  )
                                                }
                                              }
                                            },
                                            on
                                          ),
                                          [
                                            _c("v-icon", [
                                              _vm._v("fa-comment-dots")
                                            ])
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("travelService.messageRequest")
                                  ) +
                                  " "
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  })
                ],
                2
              )
            ])
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }